var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate 1",
    clipPath: "url(#clip0_69_5144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.43985 7.99983C3.43985 7.71308 3.54934 7.42636 3.76786 7.20774L10.6476 0.328104C11.0852 -0.109531 11.7948 -0.109531 12.2322 0.328104C12.6697 0.765562 12.6697 1.47497 12.2322 1.91264L6.14466 7.99983L12.232 14.0871C12.6695 14.5247 12.6695 15.234 12.232 15.6715C11.7945 16.1093 11.085 16.1093 10.6474 15.6715L3.76764 8.79192C3.54909 8.5732 3.43985 8.28648 3.43985 7.99983Z",
    fill: "#666666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_5144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.8d6e6c5618f0b98a469cdd60b86b5e67.svg";
export { ForwardRef as ReactComponent };